export const CLIENT = "client";
export const WELCOME = "welcome";
export const FREELANCER = "freelancer";
